import { css } from '@emotion/core';
export default {
  name: "jfbtp3",
  styles: "*zoom:1;&::before,&::after{display:table;content:'';}&::after{clear:both;}"
};